import React from 'react';
import { InputText } from 'primereact/inputtext';
import { Button } from 'primereact/button';
import { Growl } from 'primereact/growl';
import { Message } from 'primereact/message';
import { Dialog } from 'primereact/dialog';
import { Password } from 'primereact/password';
import { ScrollPanel } from 'primereact/scrollpanel';
import { Checkbox } from 'primereact/checkbox';

import servicioUsuario from '../servicios/ServicioUsuario';
import servicioAsignacionValoresObjetos from '../servicios/ServicioAsignacionValoresObjetos';


export class ModificacionDatosUsuario extends React.Component {

    constructor() {
        super();
        this.state = {
            mostrarModal: true,
            usuario: {},
            errores: {},
            cambiarContrasena: false
        }
    }

    componentDidMount() {
        this.obtenerDatosUsuario();
    }

    obtenerDatosUsuario(){
        servicioUsuario.obtenerDatosUsuario().then((response) => {
            if (response.data.error === false)
                this.setState({ usuario: response.data.objeto })
        })
            .catch((error) => { });
    }

    asignarValores = (event) => {
        servicioAsignacionValoresObjetos.asignarAtributosObjeto(event, this);
    }

    resetEstados() {
        this.setState({ usuario: {}, mostrarModal: false, errores: {} });
        window.location = '/Capufe/bienvenido/ticket';
    }

    validarFormulario(objeto) {
        let { cambiarContrasena } = this.state;
        let patronSeguro = new RegExp("^(?=.{7,})(((?=.*[A-Z])(?=.*[a-z]))|((?=.*[A-Z])(?=.*[0-9]))|((?=.*[a-z])(?=.*[0-9]))).*$", "g");
        const errores = {}

        if (!objeto.nombre)
            errores.nombre = "El campo es requerido.";
        if (!objeto.telefono)
            errores.telefono = "El campo es requerido.";

        if (objeto.telefono !== undefined & objeto.telefono !== null)
            if (objeto.telefono.length < 10)
                errores.telefono = "La logitud debe ser igual a 10.";

        if (cambiarContrasena === true) {

            if (!objeto.contrasena || objeto.contrasena === null) {
                errores.contrasena = "El campo es requerido.";
                return errores;
            }

            if (objeto.contrasena.length < 7) {
                errores.contrasena = "La longitud debe ser >= 7.";
                return errores;
            }

            if (!patronSeguro.test(objeto.contrasena))
                errores.contrasena = "contrasena insegura.";
        }


        return errores;

    }

    actualizarDatos() {
        let { usuario, cambiarContrasena } = this.state;

        const resultadoValidacion = this.validarFormulario(usuario);
        this.setState({ errores: resultadoValidacion });

        if (!Object.keys(resultadoValidacion).length) {

            if (cambiarContrasena === false)
                delete usuario['contrasena'];

            servicioUsuario.actualizarDatos(usuario).then((response) => {
                this.growl.show({ life: 3000, severity: (response.data.error === false ? 'success' : 'error'), summary: '', detail: response.data.mensaje });

                if (response.data.error === false)
                    setTimeout(function () { this.resetEstados(); }.bind(this), 3000);

            }).catch((error) => { })
        }
    }

    componentDidCatch() {
        this.growl.show({ life: 4000, severity: 'error', summary: 'Error', detail: "Se generó un error no controlado contacte a soporte." });
        setTimeout(function () { this.resetEstados(); }.bind(this), 3000);
    }

    componentWillUnmount() { }

    render() {

        let { usuario, errores, cambiarContrasena } = this.state;

        const pieCambiarContrasena = <div className="ui-dialog-buttonpane p-clearfix">
            <Button label="Aceptar" icon="pi-md-check" onClick={this.actualizarDatos.bind(this)} />
            <Button label="Cancelar" icon="pi-md-close" className="p-button-danger " onClick={this.resetEstados.bind(this)} />
        </div>;

        const encabezadoCambiarContrasena = <div className="encabezado" style={{justifyContent:'center' }}>
            <center>  <strong className="textoBlanco">
                Modificación de datos
                      </strong>
            </center>
        </div>
        return (
            <div>
                <Growl ref={(el) => this.growl = el} />

                <div className="content-section implementation">
                    <Dialog blockScroll={true} closeOnEscape={true} visible={this.state.mostrarModal} style={{ width: '50%', height: '70%' , padding: ".9%"}} modal={true} header={encabezadoCambiarContrasena} footer={pieCambiarContrasena} onHide={this.resetEstados.bind(this)}>
                        <ScrollPanel style={{ width: '100%', height: '300px', padding:'2%' }}>
                            <div className="p-grid">

                                <div className="p-col-12 p-md-12">
                                    <ul style={{ textAlign: 'justify', fontSize: 14, lineHeight: 'normal' }}>
                                        <li>Longitud mínima de 7 caracteres.</li>
                                        <li>Incluir por lo menos una mayúscula [A-Z].</li>
                                        <li>Incluir por lo menos un dígito [0-9].</li>
                                        <li>Incluir por lo menos un caracter especial [ !@#$%*&(){},/=.?+ ].</li>
                                        <li>No incluir espacios.</li>
                                    </ul>
                                </div>

                                <div className="p-col-12 p-md-2">
                                    <label htmlFor="correo">*Nombre</label>
                                </div>
                                <div className="p-col-12 p-md-10">
                                    <div className="p-inputgroup">
                                        <span className="p-inputgroup-addon"><i className="material-icons">person</i></span>
                                        <InputText placeholder="Nombre completo" id="nombre" name="usuario.nombre" className={errores.nombre ? 'p-error' : ''} value={usuario.nombre || ''} onChange={this.asignarValores.bind(this)} style={{ width: '100%' }} />
                                    </div>
                                    {errores.nombre ? <div><br /> <Message severity="error" text={errores.nombre} /> </div> : null}
                                </div>
                                <div className="p-col-12 p-md-2">
                                    <label htmlFor="correo">Contraseña</label>
                                </div>
                                <div className="p-col-12 p-md-9">
                                    <div className="p-inputgroup">
                                        <span className="p-inputgroup-addon"><i className="material-icons">lock_open</i></span>
                                        <Password disabled={cambiarContrasena === true ? false : true} minLength={7} placeholder="Contraseña" feedback={true} id="contrasena" name="usuario.contrasena" className={errores.contrasena ? 'p-error' : ''} value={usuario.contrasena || ''} onChange={this.asignarValores.bind(this)} style={{ width: '100%' }} />
                                    </div>
                                    {errores.contrasena ? <div><br /> <Message severity="error" text={errores.contrasena} /> </div> : null}
                                </div>
                                <div className="p-col-12 p-md-1">
                                    <Checkbox tooltip="Activa la casilla si deseas cambiar tú contraseña" onChange={e => this.setState({ cambiarContrasena: e.checked, usuario: { ...this.state.usuario, contrasena: null } })} checked={cambiarContrasena}></Checkbox>
                                </div>
                                <div className="p-col-12 p-md-2">
                                    <label htmlFor="correo">*Teléfono</label>
                                </div>
                                <div className="p-col-12 p-md-10">
                                    <div className="p-inputgroup">
                                        <span className="p-inputgroup-addon"><i className="material-icons">phone_iphone</i></span>
                                        <InputText maxLength={10} keyfilter="int" placeholder="telefono" id="telefono" name="usuario.telefono" className={errores.telefono ? 'p-error' : ''} value={usuario.telefono || ''} onChange={this.asignarValores.bind(this)} style={{ width: '100%' }} />
                                    </div>
                                    {errores.telefono ? <div><br /> <Message severity="error" text={errores.telefono} /> </div> : null}
                                </div>
                                <div className="p-col-12 p-md-2">
                                    <label htmlFor="correo">Correo</label>
                                </div>
                                <div className="p-col-12 p-md-10">
                                    <div className="p-inputgroup">
                                        <span className="p-inputgroup-addon"><i className="material-icons">email</i></span>
                                        <InputText disabled={true} placeholder="Correo" id="contrasena" name="usuario.usuario" className={errores.usuario ? 'p-error' : ''} value={usuario.usuario || ''} onChange={this.asignarValores.bind(this)} style={{ width: '100%' }} />
                                    </div>
                                    {errores.usuario ? <div><br /> <Message severity="error" text={errores.usuario} /> </div> : null}
                                </div>

                            </div>
                        </ScrollPanel>
                    </Dialog>

                </div>
            </div>
        );
    }
} 